import React, { useState } from "react";

import FundModal from "../Modals/FundModal";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";


import deposit from "../../assets/icons/deposit.svg";
import withdraw from "../../assets/icons/withdraw.svg";
import RefreshButton from "../Loaders/RefreshButton";
import BalanceCardSkeleton from "../Skeletons/BalanceCardSkeleton";

export default function Balancecardv2({ walletBalance, isValidating, mutate }) {
  const { user } = useSelector((state) => ({
    user: state.Profile.user,
  }));

  const [showBalance, setShowBalance] = useState(false);

  if (walletBalance === undefined) {
    return <BalanceCardSkeleton />;
  }

  const isBalanceAvaiable = walletBalance ? "balancecardv2" : "balancecardv2 active";

  return (
    <div className={isBalanceAvaiable}>
      <div className="balancecardv2__container">

        {/* Header: Label + Controls */}
        {/* Header: Label + Controls */}
        <div className="balancecardv2__top">
          <p className="balancecardv2__top--text">Simply Account Balance</p>
          <div className="d-flex align-items-center gap-2">
            <RefreshButton isValidating={isValidating} mutate={mutate} />
          </div>
        </div>

        {/* Balance Display */}
        <div className="balancecardv2__numbers">
          <div className="balancecardv2__numbers--digits d-flex align-items-center gap-2">
            {showBalance ? (
              `${user?.currency_symbol} ${walletBalance}`
            ) : (
              <span className="text-muted opacity-50" style={{ letterSpacing: "3px" }}>******</span>
            )}
            <i
              className={`bx ${showBalance ? "bx-show" : "bx-hide"}`}
              style={{ fontSize: '20px', cursor: 'pointer', opacity: 0.6, color: '#000', marginLeft: '10px', transform: 'translateY(-2px)' }}
              onClick={() => setShowBalance(!showBalance)}
            />
          </div>
          {/* Optional: Add a small status text or sub-label if needed */}
          {/* <span className="text-success">+2.5% this month</span> */}
        </div>

        {/* Action Buttons */}
        <div className="balancecardv2__actions">
          <Link to="/withdraw-money" className="balancecardv2__action-btn withdraw">
            <img src={withdraw} alt="" />
            <span>Withdraw</span>
          </Link>

          <Link to="/deposit-money" className="balancecardv2__action-btn deposit">
            <img src={deposit} alt="" />
            <span>Deposit</span>
          </Link>
        </div>

      </div>
    </div>
  );
}

